// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2915) return "static/chunks/2915-94b352d9.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 998 ? "b2ccfc24" : chunkId) + "." + {"998":"1e26985b808bfe17","1827":"39ad08b966578cea","3455":"8bac18648d5c70d0","4451":"682703b65e71461e","9694":"5a4099ce8a321878"}[chunkId] + ".js";
};